// Roadmaps referencing shared topics by id
export const roadmaps = [
  {
    id: 'devops',
    title: 'DevOps',
    description: 'From Linux to Kubernetes, CI/CD, IaC, and observability.',
    image: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?auto=format&fit=crop&w=1200&q=60',
    topics: [
      'linux-basics',
      'git-and-github',
      'networking-fundamentals',
      'cloud-basics',
      'docker',
      'kubernetes',
      'ci-cd',
      'terraform',
      'monitoring-logging',
      'security-fundamentals'
    ]
  },
  {
    id: 'dsa',
    title: 'Data Structures & Algorithms',
    description: 'Core CS fundamentals and problem solving.',
    image: 'https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?auto=format&fit=crop&w=1200&q=60',
    topics: ['programming-python-basics', 'data-structures-algorithms', 'system-design-basics', 'git-and-github']
  },
  {
    id: 'machine-learning',
    title: 'Machine Learning',
    description: 'Build, evaluate, and deploy ML models.',
    image: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1200&q=60',
    topics: ['programming-python-basics', 'math-for-ml', 'machine-learning-fundamentals', 'sql-and-databases', 'deep-learning-basics']
  },
  {
    id: 'gen-ai',
    title: 'Generative AI',
    description: 'Transformers, prompts, and LLMOps.',
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=1200&q=60',
    topics: ['programming-python-basics', 'machine-learning-fundamentals', 'deep-learning-basics', 'nlp-basics', 'genai-fundamentals', 'prompt-engineering', 'llmops']
  },
  {
    id: 'power-bi',
    title: 'Power BI',
    description: 'Model, transform, and visualize business data.',
    image: 'https://images.unsplash.com/photo-1517148815978-75f6acaaf32c?auto=format&fit=crop&w=1200&q=60',
    topics: ['power-bi-fundamentals', 'data-modeling', 'power-query', 'dax-basics', 'sql-and-databases']
  },
  {
    id: 'frontend',
    title: 'Frontend',
    description: 'Modern web apps with React and best practices.',
    image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=60',
    topics: ['frontend-fundamentals', 'react-basics', 'api-design-rest', 'testing-automation']
  },
  {
    id: 'backend',
    title: 'Backend',
    description: 'APIs, databases, security, and deployment.',
    image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=1200&q=60',
    topics: ['backend-node-express', 'api-design-rest', 'sql-and-databases', 'security-fundamentals', 'system-design-basics', 'cloud-basics', 'docker']
  },
  {
    id: 'cloud-architect',
    title: 'Cloud Architect',
    description: 'Design reliable, scalable cloud systems on AWS/Azure/GCP.',
    image: 'https://images.unsplash.com/photo-1566241440091-ec10de8db2e1?auto=format&fit=crop&w=1200&q=60',
    topics: ['networking-fundamentals', 'linux-basics', 'cloud-basics', 'aws-fundamentals', 'azure-fundamentals', 'gcp-fundamentals', 'terraform', 'security-fundamentals']
  },
  {
    id: 'data-engineering',
    title: 'Data Engineering',
    description: 'Pipelines, orchestration, and scalable storage/compute.',
    image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1200&q=60',
    topics: ['programming-python-basics', 'data-engineering-fundamentals', 'spark-basics', 'airflow-basics', 'sql-and-databases', 'cloud-basics']
  },
  {
    id: 'mobile',
    title: 'Mobile',
    description: 'React Native apps and mobile patterns.',
    image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1200&q=60',
    topics: ['mobile-react-native-basics', 'api-design-rest', 'testing-automation']
  },
  {
    id: 'qa-automation',
    title: 'QA Automation',
    description: 'Test strategies, frameworks, and CI integration.',
    image: 'https://images.unsplash.com/photo-1515879218367-8466d910aaa4?auto=format&fit=crop&w=1200&q=60',
    topics: ['testing-automation', 'programming-python-basics', 'ci-cd']
  },
  {
    id: 'cybersecurity',
    title: 'Cybersecurity',
    description: 'Security essentials for apps and infra.',
    image: 'https://images.unsplash.com/photo-1556157381-36fda6e46a16?auto=format&fit=crop&w=1200&q=60',
    topics: ['cybersecurity-basics', 'linux-basics', 'networking-fundamentals', 'security-fundamentals', 'cloud-basics']
  }
];

export default roadmaps;
